<template>
  <div class="h-100 d-block">
    <vue-apex-charts
      type="bar"
      width="100%"
      height="100%"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  name: 'StackedVerticalBarCharts',
  components: {
    VueApexCharts,
  },
  props: {
    seriesData: {
      type: Array,
      required: true,
    },
    categoriesData: {
      type: Array,
      required: true,
    },
    // eslint-disable-next-line vue/require-default-prop
    colorsData: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        colors: [$themeColors.danger, $themeColors.info, $themeColors.warning, $themeColors.success],
        chart: {
          type: 'bar',
          width: '100%',
          height: '100%',
          toolbar: {
            show: false,
          },
          stacked: true,
          stackType: '100%',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              show: true,
              total: {
                enabled: true,
                offsetX: 0,
                offsetY: -5,
                formatter(w) {
                  const formatter = new Intl.NumberFormat('tr-TR', {
                    minimumFractionDigits: 0,
                  })
                  return formatter.format(w)
                },
                style: {
                  fontSize: '12px',
                  fontWeight: 800,
                  colors: ['#000'],
                },
              },
            },
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff'],
        },
        xaxis: {
          categories: [],
          labels: {
            formatter(val) {
              return `${val}`
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter(val) {
              return `${val} Adet`
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
          position: 'top',
          horizontalAlign: 'center',
          offsetX: 0,
          offsetY: 0,
        },
      },
    }
  },
  watch: {
    seriesData: 'setData',
    categoriesData: 'setData',
    colorsData: 'setData',
  },
  created() {
    this.setData()
  },
  methods: {
    setData() {
      this.series = this.seriesData
      this.chartOptions.xaxis.categories = this.categoriesData
      this.chartOptions.colors = this.colorsData
      // this.addTotalAnnotations()
    },
  },
}
</script>
